import React from 'react'
import Img from 'gatsby-image'

import styles from './styles.module.scss'

export const HeroWave = ({ img, copy }) => (
  <div className={styles.hero}>
    <div className={styles.heroTextWrapper}>
      <h1 className={styles.heroText}>{copy}</h1>
    </div>
    <Img className={styles.heroImg} fluid={img} alt="" />
  </div>
)
